import React, { useRef, useState, useEffect, useContext } from "react";
import * as S from "./styles";
import PJsvg from "../../assets/navbar/Pessoa_juridica_on_light_blue.svg";
import PJsvgPlus from "../../assets/navbar/Pessoa_juridica_on_light_blue_plus.svg";
import people_pj from "../../services/people_pj";
import person from "../../services/person";
import toDateISO from "../../utils/formatData";
import desmaskIfNumber from "../../utils/desmaskIfNumber";

import { Formik, Form, Field } from "formik";

import InputText from "../../components/InputText";
import Button from "../../components/Button";
import Navbar from "../../components/Navbar";
import InputSearch from "../../components/InputSearch";
import ListCompanyType from "../../components/ListCompanyTypes";

import { useParams } from "react-router-dom";

import { toast } from "react-toastify";
import firstSchema from "./validations/schemaValidation";
import history from "../../utils/history";
import { IoSearch } from "react-icons/io5";

import SkeletonRadioInput from "../../components/SkeletonRadioInput";
import Skeleton from "../../components/skeleton";
import { Context } from "../../context/globalContext";

export default function RegistrationUser() {
  const formRef = useRef(null);
  const { id } = useParams();
  const [formData, setFormData] = useState();
  const [cityData, setCityData] = useState();
  const [initialState, setInitialState] = useState({});
  const [editingPerson, setEditingPerson] = useState(false);

  const globalContext = useContext(Context);

  const getMainEmail = (emails) => {
    let mainEmail;
    for (let index = 0; index < emails.length; index++) {
      let currentElement = emails[index];
      if (currentElement.emailPrincipal === true) {
        mainEmail = currentElement;
        break;
      } else {
        mainEmail = "";
      }
    }
    return mainEmail;
  };

  useEffect(() => {
    if (id) {
      getDataByUserId();
    }
    id !== undefined && setEditingPerson(true);
  }, [id]);

  const getDataByUserId = async () => {
    await person
      .listData(id)
      .then(async (ev) => {
        const data = ev?.data;
        if (data) {
          setInitialState(data);

          let dataNascimento = await new Date(
            data?.dataNascimento
          ).toLocaleDateString("pt-BR");

          const pessoaContatoEmail = data?.pessoaContatoEmail;
          const mainEmail = getMainEmail(pessoaContatoEmail);

          const pessoaContatoTelefone = data?.pessoaContatoTelefone;
          const enderecos = data?.enderecos;
          const lastPhone =
            pessoaContatoTelefone[pessoaContatoTelefone?.length - 1];
          const lastEnderecos = enderecos[enderecos?.length - 1];
          const pessoaContato = data?.pessoaJuridica?.nomeContato;
          const faturamentoAnual = data?.pessoaJuridica?.faturamentoAnual;
          const porteDaEmpresa = data?.pessoaJuridica?.porteEmpresa;
          const capitalSocial = data?.pessoaJuridica?.valorCapitalSocial;
          const tipoEmpresa = data?.pessoaJuridica?.tipoEmpresa;

          setInitialState({
            ...data,
            dataNascimento,
            pessoaContatoEmail: mainEmail,
            pessoaContatoTelefone: lastPhone,
            enderecos: lastEnderecos,
            pessoaContato,
            faturamentoAnual,
            porteDaEmpresa,
            capitalSocial,
            tipoEmpresa,
          });
        }
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Erro ao buscar dados!");
        }
      });
  };

  const sendData = async (dataForm) => {
    globalContext.setIsLoading(true);
    let capSoc = dataForm?.capitalSocial
      ? dataForm?.capitalSocial
          .toString()
          ?.replaceAll("R$", "")
          ?.replaceAll(".", "")
          ?.replaceAll(",", ".")
      : dataForm?.pessoaJuridica?.capitalSocial
      ? dataForm?.pessoaJuridica?.capitalSocial
      : "0";

    let fatAnual = dataForm?.faturamentoAnual
      ? dataForm?.faturamentoAnual
          .toString()
          ?.replaceAll("R$", "")
          ?.replaceAll(".", "")
          ?.replaceAll(",", ".")
      : dataForm?.pessoaJuridica?.faturamentoAnual
      ? dataForm?.pessoaJuridica?.faturamentoAnual
      : "0";

    let pessoaEndereco = dataForm?.enderecos
      ? [
          {
            cep: dataForm?.enderecos?.cep,
            bairro: dataForm?.enderecos?.bairro,
            uf: dataForm?.enderecos?.uf,
            logradouro: dataForm?.enderecos?.logradouro,
            numero: dataForm?.enderecos?.numero,
            complemento: dataForm?.enderecos?.complemento,
            municipio: {
              ...cityData,
            },
          },
        ]
      : [];

    let pessoaContatoTelefone = dataForm?.pessoaContatoTelefone
      ? [
          {
            telefone: dataForm?.pessoaContatoTelefone?.telefone,
            tipoContato: "PESSOAL",
          },
        ]
      : [];

    let pessoaContatoEmail = dataForm?.pessoaContatoEmail
      ? [
          {
            email: dataForm?.pessoaContatoEmail?.email,
          },
        ]
      : [];

    const dataSending = {
      cpfCnpj: desmaskIfNumber(dataForm?.cpfCnpj),
      nome: dataForm?.nome,
      dataNascimento: toDateISO(dataForm?.dataAbertura),
      tipoPessoa: "PESSOA_JURIDICA",
      nomeFantasia: dataForm?.nomeFantasia,
      site: dataForm?.site,
      dataAbertura: dataForm?.dataNascimento,
      pessoaJuridica: {
        id: dataForm?.pessoaJuridica?.id,
        inscricaoMunicipal: dataForm?.pessoaJuridica?.inscricaoMunicipal,
        inscricaoEstadual: dataForm?.pessoaJuridica?.inscricaoEstadual,
        nomeContato: dataForm?.pessoaContato,
        porteEmpresa: dataForm?.porteDaEmpresa,
        valorCapitalSocial: Number(capSoc),
        faturamentoAnual: Number(fatAnual),
        dadosBancarios: null,
        tipoEmpresa: dataForm?.tipoEmpresa,
      },
      enderecos: pessoaEndereco,
      pessoaContatoEmail: pessoaContatoEmail,
      pessoaContatoTelefone: pessoaContatoTelefone,
    };

    const handleEditing = async () => {
      try {
        const response = await people_pj.editingData(id, dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados atualizados com sucesso!");
        } else if (!response) {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
        getDataByUserId();
      }
    };

    const handleCreate = async () => {
      try {
        const response = await people_pj.sendData(dataSending);
        if (response && (response.status === 201 || response.status === 200)) {
          toast.success("Dados cadastrados com sucesso!");
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error(
            "Erro ao salvar dados, verifique os dados e tente novamente!"
          );
        }
      } finally {
        globalContext.setIsLoading(false);
      }
    };

    if (id) {
      handleEditing();
    } else {
      handleCreate();
    }
  };

  const handleSubmit = () => {
    if (formRef.current) {
      if (formRef.current.isValid) {
        sendData(formRef.current.values);
      }
    }
  };

  useEffect(() => {
    Object.keys(formRef.current.values).length >= 1
      ? setFormData(true)
      : setFormData(false);
  }, [formRef, formData]);

  const handleSearch = (item) => {
    setCityData(item);
  };

  const findUserInSgs = async () => {
    const values = formRef.current.values;
    if (values.cpfCnpj && values.cpfCnpj.length > 0) {
      try {
        const integrationResponse = await person.integrationPerson(
          desmaskIfNumber(values.cpfCnpj)
        );
        if (integrationResponse && integrationResponse.status === 200) {
          history.push(
            `/cadastro-pessoa-juridica/${integrationResponse?.data?.id}`
          );
        }
      } catch (err) {
        if (err?.response?.data?.message) {
          toast.error(err?.response?.data?.message);
        } else {
          toast.error("Preencha um cnpj válido.");
        }
      }
    } else {
      toast.error("Preencha um cnpj válido.");
    }
  };

  return (
    <>
      <Navbar className="navbar" />
      <S.Wrapper>
        <S.Header>
          <S.BoxUser>
            <S.Image src={PJsvg} />
            <div>
              <S.Title>Cadastro de pessoa jurídica</S.Title>
              <S.Description>Informações básicas da pessoa</S.Description>
            </div>
          </S.BoxUser>
        </S.Header>

        <S.Content>
          <Formik
            innerRef={formRef}
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={firstSchema}
            onSubmit={(values) => handleSubmit}
          >
            {({ errors, touched, values, setFieldValue }) => (
              <Form>
                <Field
                  name="cpfCnpj"
                  id="cpfCnpj"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="50%"
                        label="CNPJ*:"
                        maskChar=""
                        mask="99.999.999/9999-99"
                        currency="false"
                        disabled={id}
                        iconComponent={
                          !id ? (
                            <IoSearch
                              onClick={() => findUserInSgs()}
                              cursor="pointer"
                              color="#00a2e0"
                              size="25px"
                            />
                          ) : (
                            <></>
                          )
                        }
                        error={errors.cpfCnpj && touched.cpfCnpj}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <p>{errors.cpfCnpj}</p>
                <S.InputBox>
                  <Field
                    name="nome"
                    id="nome"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Razão social*:"
                          currency="false"
                          error={errors.nome && touched.nome}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                  <Field
                    name="dataNascimento"
                    id="dataNascimento"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          type="text"
                          label="Data de abertura:"
                          maskChar=""
                          mask="99/99/9999"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="nomeFantasia"
                    id="email"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Nome fantasia*:"
                          currency="false"
                          error={errors.nomeFantasia && touched.nomeFantasia}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="pessoaContato"
                    id="pessoaContato"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Pessoa de contato:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <Field
                  name="site"
                  id="site"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <InputText
                        {...field}
                        type="text"
                        width="58%"
                        label="Site:"
                        currency="false"
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />
                <S.InputBox>
                  <Field
                    name="pessoaContatoEmail.email"
                    id="email"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="E-mail:"
                          type="email"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="pessoaContatoTelefone.telefone"
                    id="telefone"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Telefone:"
                          mask="(99)99999-9999"
                          maskChar=""
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="faturamentoAnual"
                    id="faturamentoAnual"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Faturamento anual:"
                          currency="true"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="capitalSocial"
                    id="capitalSocial"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Capital social:"
                          currency="true"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <Field
                  name="tipoEmpresaPJ"
                  id="tipoEmpresaPJ"
                  render={({ field }) =>
                    !globalContext.isLoading ? (
                      <ListCompanyType
                        {...field}
                        width="58%"
                        label="Tipo de empresa:"
                        currency="false"
                        value={values?.tipoEmpresa?.id}
                        onChange={(e) => {
                          setFieldValue("tipoEmpresa", e);
                        }}
                      />
                    ) : (
                      <Skeleton type="input" />
                    )
                  }
                />

                <S.InputRadioBox>
                  <Field
                    name="porteDaEmpresa"
                    id="porteDaEmpresa"
                    render={({ field }) => (
                      <S.InputRadio>
                        {!globalContext.isLoading ? (
                          <p>Porte da empresa:</p>
                        ) : (
                          <Skeleton type="radioParagraph" />
                        )}
                        <label>
                          {!globalContext.isLoading ? (
                            <>
                              <input
                                type="radio"
                                name="porteDaEmpresa"
                                className="radio"
                                value="PEQUENA"
                                checked={values.porteDaEmpresa === "PEQUENA"}
                                onChange={() =>
                                  setFieldValue("porteDaEmpresa", "PEQUENA")
                                }
                              />
                              Pequena{" "}
                            </>
                          ) : (
                            <SkeletonRadioInput />
                          )}
                        </label>
                        <label>
                          {!globalContext.isLoading ? (
                            <>
                              <input
                                type="radio"
                                name="porteDaEmpresa"
                                className="radio"
                                value="MEDIA"
                                checked={values.porteDaEmpresa === "MEDIA"}
                                onChange={() =>
                                  setFieldValue("porteDaEmpresa", "MEDIA")
                                }
                              />
                              Média{" "}
                            </>
                          ) : (
                            <SkeletonRadioInput />
                          )}
                        </label>
                        <label>
                          {!globalContext.isLoading ? (
                            <>
                              <input
                                type="radio"
                                name="porteDaEmpresa"
                                className="radio"
                                value="GRANDE"
                                checked={values.porteDaEmpresa === "GRANDE"}
                                onChange={() =>
                                  setFieldValue("porteDaEmpresa", "GRANDE")
                                }
                              />
                              Grande{" "}
                            </>
                          ) : (
                            <SkeletonRadioInput />
                          )}
                        </label>
                      </S.InputRadio>
                    )}
                  ></Field>
                </S.InputRadioBox>

                <S.SubTitle>Endereço</S.SubTitle>

                <S.InputBox>
                  <Field
                    name="enderecos.logradouro"
                    id="logradouro"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Logradouro:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                  <Field
                    name="enderecos.numero"
                    id="numero"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Número:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox columns="1fr 1fr 1fr" gap="1rem">
                  <Field
                    name="enderecos.complemento"
                    id="Complemento"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Complemento:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="enderecos.bairro"
                    id="bairro"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          {...field}
                          label="Bairro:"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="enderecos.cep"
                    id="cep"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          style={{ marginLeft: "0" }}
                          {...field}
                          label="CEP:"
                          maskChar=""
                          mask="99999-999"
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>

                <S.InputBox>
                  <Field
                    name="enderecos.municipio.descricao"
                    id="cidade"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputSearch
                          {...field}
                          handleSearch={handleSearch}
                          initialValue={initialState?.enderecos?.municipio}
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />

                  <Field
                    name="enderecos.uf"
                    id="estado"
                    render={({ field }) =>
                      !globalContext.isLoading ? (
                        <InputText
                          label="Estado:"
                          {...field}
                          disabled
                          value={cityData?.estado?.nome}
                          currency="false"
                        />
                      ) : (
                        <Skeleton type="input" />
                      )
                    }
                  />
                </S.InputBox>
              </Form>
            )}
          </Formik>

          <S.ButtonContainer>
            <Button button="primary" onClick={history.goBack}>
              Voltar
            </Button>
            <Button button="primary" onClick={() => handleSubmit()}>
              Salvar cadastro
            </Button>
          </S.ButtonContainer>
        </S.Content>
      </S.Wrapper>
    </>
  );
}
